/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  AdminAccountantApprovalEditAccountingAttributesCustomisationDto,
  AdminAccountantExportEditAccountingAttributesCustomisationDto,
  AdminAccountantVerificationEditAccountingAttributesCustomisationDto,
  AllowApproverToEditAccountingAttributesCustomisationDto,
  EditableAccountingAttributesCustomisationDto,
  EmployeeEditAttributesCustomisationDto,
  PayFromMossCustomisationDto,
  UpdateInvoiceCustomisationPayload,
  VerificationStepCustomisationDto,
  VerifierVerificationEditAccountingAttributesCustomisationDto,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiInvoicesCustomisationController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-invoices-customisation-controller
   * @name FindAllCustomisations
   * @request GET:/api/v1/invoices/customisation
   */
  findAllCustomisations = (params: RequestParams = {}) =>
    this.http.request<
      (
        | AdminAccountantApprovalEditAccountingAttributesCustomisationDto
        | AdminAccountantExportEditAccountingAttributesCustomisationDto
        | AdminAccountantVerificationEditAccountingAttributesCustomisationDto
        | AllowApproverToEditAccountingAttributesCustomisationDto
        | EditableAccountingAttributesCustomisationDto
        | EmployeeEditAttributesCustomisationDto
        | PayFromMossCustomisationDto
        | VerificationStepCustomisationDto
        | VerifierVerificationEditAccountingAttributesCustomisationDto
      )[],
      any
    >({
      path: `/v1/invoices/customisation`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findAllCustomisationsPath = '/v1/invoices/customisation'
  static findAllCustomisationsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-invoices-customisation-controller
   * @name UpdateInvoiceCustomisation
   * @request PUT:/api/v1/invoices/customisation
   */
  updateInvoiceCustomisation = (
    data: UpdateInvoiceCustomisationPayload,
    params: RequestParams = {},
  ) =>
    this.http.request<
      | AdminAccountantApprovalEditAccountingAttributesCustomisationDto
      | AdminAccountantExportEditAccountingAttributesCustomisationDto
      | AdminAccountantVerificationEditAccountingAttributesCustomisationDto
      | AllowApproverToEditAccountingAttributesCustomisationDto
      | EditableAccountingAttributesCustomisationDto
      | EmployeeEditAttributesCustomisationDto
      | PayFromMossCustomisationDto
      | VerificationStepCustomisationDto
      | VerifierVerificationEditAccountingAttributesCustomisationDto,
      any
    >({
      path: `/v1/invoices/customisation`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateInvoiceCustomisationPath = '/v1/invoices/customisation'
  static updateInvoiceCustomisationMethod = 'PUT'
}
